import React from 'react';

// COMPONENTS
import Folder from '../folderComponent';

// Tuile "Vos ressources" : on n'affiche que les 5 premiers dossiers (selon l'ordre
// défini en admin) et un bouton "Voir plus" renvoyant vers le SharePoint.
const RESOURCES_TILE_TITLE = 'Vos ressources';
const RESOURCES_MAX_VISIBLE = 5;
const RESOURCES_MORE_URL = 'https://groupeai.sharepoint.com/:f:/r/sites/TeamAltitudeInfra/Documents%20partages/Vos%20Ressources?csf=1&web=1&e=gHlJuq';

const ButtonTile = ({ user_id, tile_id, title, data, isEditing = false, isViewing = false }) => {

    const buttonTitles = Object.keys(data).filter(key => key.startsWith('button_title#'));
    const buttons = buttonTitles.map(titleKey => {
        const index = titleKey.split('#')[1];
        const buttonTitle = data[`button_title#${index}`] || 'Google';
        const buttonUrl = data[`button_url#${index}`] || 'https://www.google.com/';
        const buttonColor = data[`button_color#${index}`] || '#000000';
        return {
            // Le suffixe des clés de TIL_DATA est le BTN_ID du dossier : c'est
            // lui qui permet de compter les clics dossier par dossier.
            id: Number(index),
            title: buttonTitle,
            url: buttonUrl,
            color: buttonColor
        };
    }).filter(button => button.title && button.url);

    const isResourcesTile = title === RESOURCES_TILE_TITLE;
    const visibleButtons = isResourcesTile ? buttons.slice(0, RESOURCES_MAX_VISIBLE) : buttons;
    const hasMore = isResourcesTile && buttons.length > RESOURCES_MAX_VISIBLE;

    return (
        <div className="p-4 rounded-lg tile-animate flex flex-col h-full w-full overflow-hidden">
            <h3 className="text-lg poppins-bold text-center text-blanc flex-shrink-0">{title}</h3>
            <div className="mt-4 flex-1 min-h-0 flex flex-col gap-3 overflow-y-auto">
                {visibleButtons.length > 0 ? (
                    visibleButtons.map((button, index) => (
                        <div key={button.id} className="flex justify-start">
                            <Folder user_id={user_id} tile_id={tile_id} button_id={button.id} title={button.title} url={button.url} folderColor={button.color} isEditing={isEditing} isViewing={isViewing} />
                        </div>
                    ))
                ) : (
                    <div>
                        <p>Aucun bouton disponible</p>
                    </div>
                )}
            </div>
            {hasMore && (
                !isEditing && !isViewing ? (
                    <a
                        href={RESOURCES_MORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-shrink-0 pt-3 text-center text-sm poppins-bold text-blanc/90 hover:text-blanc underline"
                    >
                        Voir plus
                    </a>
                ) : (
                    <span className="flex-shrink-0 pt-3 text-center text-sm poppins-bold text-blanc/90 underline">
                        Voir plus
                    </span>
                )
            )}
        </div>
    );
};

export default ButtonTile;
